import React, { Component } from "react";
import { Link } from "react-router-dom";

class Footer extends Component {
  render() {
    return (
      <div className="background-gray">
        <div className="footer-divider w-100 bw1 bt"></div>
        <div className="flex justify-center items-center nowrap footer">
          <Link to="/guidelines" className="no-underline link">
            Guidelines
          </Link>
          <span className="pl2 pr2">|</span>
          <Link to="/faq" className="ml1 no-underline link">
            FAQ
          </Link>
          <span className="pl2 pr2">|</span>
          <Link to="/about" className="ml1 no-underline link">
            About
          </Link>
          <span className="pl2 pr2">|</span>
          <a href="mailto:hello@mln.dev" className="ml1 no-underline link">
            Contact us
          </a>
        </div>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js